import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery'


@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  styles: [`
  .toggle-collapse {
    margin-left:0px;
  }
  `]
})
export class AdminLayoutComponent implements OnInit {
  isCollapse:boolean = false;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    document.addEventListener('click',function(e){
      const target= e.target as HTMLElement;
      if(!target.closest('.wc-date-container') && !target.closest('.wc-date-popover')){
        $('.wc-date-container').each(function(){
          if($(this).parent().find('.wc-date-popover[hidden]').length <=0){
            $(this).trigger('click');
          }
        })
      }
    })
  }


  ontoggleClick(){
    this.isCollapse = !this.isCollapse;
  }

  getMyStyles(){
    if(this.isCollapse){
      let myStyles = {
        'margin-left': this.isCollapse ? '0px' : '250px'
     };
      return myStyles;
    }
    else{
      let myStyles = {
        //'margin-left': this.isCollapse ? '0px' : '250px'
     };
     return myStyles;
    }
  }
}
